export default __webpack_public_path__ + "96424dc336bd2b4f09d3653db7baeb05.svg";